import * as gfunctions from '../../../js/generalFunctions';

CCL.pdpSfPackage = {
  autoload: [
    ['oneQuantity', $('.static-qty').length > 0],
    ['oneQuantity', $('.terms-conditions-btn').length > 0],
    ['pdpPackageAjax', $('#alcoholAtcModal').length > 0],
    ['buttonDisableConidtions', $('.add-to-cart-sfp').length > 0],
    ['RestrictUserFromPDP', $('.c-pdp-card').length > 0],
    ['RestrictUserMinus', $('.c-pdp-card').length > 0]
  ],

  VariantQuantity: null,

  oneQuantity() {
    const stateroomLength = $('.custom-control.custom-checkbox.stateroom-check').length;
    const disableLength = $('.custom-control.custom-checkbox.stateroom-check.stateroom-disabled').length;

    if (stateroomLength === disableLength) {
      $('.static-qty').hide();
      if ($('#specialFunshopCaseInput').val() === 'true') {
        $('.common-pdp-error-message').hide();
        $('.pdp-error-msg').show();
      } else {
        $('.common-pdp-error-message').show();
        $('.pdp-error-msg').hide();
      }
    } else {
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each((ind, ele) => {
        if ($(ele.parentElement).hasClass('stateroom-disabled')) {
          $(ele.parentElement.nextElementSibling).show();
        }
      });
    }
  },
  RestrictUserFromPDP() {
    $('.c-pdp-card').on('click', '.increment-btn', (event) => {
      this.pdpCruiseCashRestrication();
    });
  },

  pdpCruiseCashRestrication(afterAjax = false) {
    if ($('.c-pdp-card .general-add-to-cart-btn')[0].dataset.funshopcategorycode && $('.c-pdp-card .general-add-to-cart-btn')[0].dataset.funshopcategorycode === 'cruise-cash') {
      // run this only for price values variant not for other variants
      const variantValue = Number($('.c-pdp-card .btn-add-cart').data('price'));
      if (!isNaN(variantValue)) { // eslint-disable-line
        const targetElement = $('.c-pdp-card .quantity-btn-wrap').find('.quantity-input');
        this.VariantQuantity = afterAjax ? Number($(targetElement).val()) : Number($(targetElement).val()) + 1;
        const price = Number(variantValue);
        const localAmount = Number(localStorage.getItem('cruisecashcartamount'));
        let reqdQty = (500 - localAmount) / variantValue;
        reqdQty = Math.floor(reqdQty);
        if (this.VariantQuantity >= Number(reqdQty)) {
          $('.increment-btn').attr('disabled', 'disabled');
          $('.increment-btn').css('pointer-events', 'none');
          $('.increment-btn').css('opacity', '0.4');
          $('.cc-error').remove();
          setTimeout(() => {
            $(`<div class='cc-error'
                aria-live='assertive'
                role='alert'
                style='color:darkred'>
        Cruise Cash limit is $500 per stateroom.
        </div>`).insertAfter('.c-pdp-card .quantity-btn-wrap');
          }, 500);
        } else {
          $('.increment-btn').removeAttr('disabled');
          $('.increment-btn').css('pointer-events', 'auto');
          $('.increment-btn').css('opacity', '1');
        }

        if ((price + localAmount) > 500) {
          $('.c-pdp-card .btn-add-cart').attr('disabled', 'disabled');
        }
      }
    }
  },

  RestrictUserMinus() {
    $('.c-pdp-card').on('click', '.decrement-btn', (event) => {
      $('.cc-error').remove();
      $('.increment-btn').css('pointer-events', 'auto');
      $('.increment-btn').css('opacity', '1');
      $('.increment-btn').removeAttr('disabled');
    });
  },
  buttonDisableConidtions() {
    const hasVariant = $('#hasVariant').val();
    if ($('.flavor-wrap').length > 0) {
      if (hasVariant === 'false') {
        $('.add-to-cart-sfp').removeAttr('disabled');
        if ($('.add-to-cart-sfp').attr('data-bookingIds') === '') {
          $('.add-to-cart-sfp').attr('disabled', 'disabled');
        }
      } else {
        $('.add-to-cart-sfp').attr('disabled', 'disabled');
        $('.stateroom-check').addClass('stateroom-disabled');
        $('.stateroom-check').find('.parent-check').attr('disabled', 'disabled');
        $('.stateroom-check').find('.parent-check').removeAttr('checked');
        $('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg');
        $('.drop-icon').addClass('gray');
      }
    } else if ($('.add-to-cart-sfp').attr('data-bookingIds') === '') {
      $('.add-to-cart-sfp').attr('disabled', 'disabled');
    } else {
      $('.add-to-cart-sfp').removeAttr('disabled');
    }
  },

  bookingData(productCodePost, event, currentElement) {
    const bookings = [];
    let dataObj = {};
    const booking = currentElement.parents('.c-cart-card,.c-pdp-card,.alcohol-atc-modal-dialog').find('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked');
    booking.each((index, element) => {
      const bookingIdValue = element.dataset.bookingid;
      const guestArray = [];
      let quantity = '';
      let ac = '';
      if (event.target.dataset.ispdp === 'true') {
        ac = $(element.parentElement.children[3]);
        quantity = $('#maxQuantitySfp').val();
      } else {
        ac = $(element.parentElement);
        quantity = 1;
      }
      ac.find('.guests-check > input[type="checkbox"]:checked').each((i, elem) => {
        if (!$(elem).prop('disabled')) {
          const guestValue = elem.dataset.guestid;
          const guestObj = {
            guestId: guestValue
          };
          guestArray.push(guestObj);
        }
      });
      const bookingData = {
        bookingId: bookingIdValue,
        qty: quantity,
        guestIds: guestArray
      };
      bookings.push(bookingData);
    });
    dataObj.bookings = bookings;
    dataObj.productCodePost = productCodePost;
    dataObj = JSON.stringify(dataObj);
    return dataObj;
  },
  pdpPackageAjax() {
    $('body').on('click', '.add-to-cart-sfp', (event) => {
      gfunctions.showLoader();
      const hasupsell = $(event.target).attr('data-hasupsell');
      const sailingInfoNeeded = $(event.target).attr('data-sailingInfoNeeded');
      const csrf = $('.add-to-cart-sfp').data('csrf') ? $('.add-to-cart-sfp').data('csrf') : $('#csrfSessionToken').data('csrf');
      let targetElement = '';
      let dataObj;

      if (sessionStorage.getItem('producttype') === 'SFAP') {
        dataObj = sessionStorage.getItem('sessionTemplateObj');
        sessionStorage.removeItem('producttype');
      } else {
        targetElement = $(event.target).data('hasvariants');
        const productCodePost = $(event.target).data('productcode');
        dataObj = this.bookingData(productCodePost, event, $('.add-to-cart-sfp'));
      }

      const pageType = $('#pagetype').data('pagetype');
      dataObj = JSON.parse(dataObj);
      dataObj.pageType = pageType;
      if (pageType === 'CATEGORY') {
        dataObj.productPosition = localStorage.getItem('productposition');
        dataObj.pageNumber = localStorage.getItem('pageNumber');
        dataObj.categoryName = localStorage.getItem('sascategorycode');
        dataObj.pageType = pageType;
      }
      dataObj = JSON.stringify(dataObj);

      if (hasupsell === 'true' &&
        typeof hasupsell !== typeof undefined &&
        hasupsell !== false &&
        (sailingInfoNeeded === 'false' || typeof sailingInfoNeeded === typeof undefined)) {
        CCL.upSellProductModal.loadGlobalUpsellModal(event);
        return;
      }

      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/specialFS/add',
          contentType: 'application/json',
          data: dataObj,
          headers: {
            CSRFToken: csrf
          }
        }).done((response) => {
          gfunctions.hideLoader();
          if (response.addedToCart === true) {
            gfunctions.updateHeaderCartWidget(response);
            gfunctions.hideModal('alcoholAtcModal');
            CCL.addToCart.successModal(response);
          }
        }).fail(() => {
          gfunctions.hideLoader();
          console.log('Something went wrong');
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-special-occassions-decors/pdp-fs-package.js